import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from 'src/app.config';
import { getAuthToken } from '../../auth.interceptor';

@Injectable({ providedIn: 'root' })
export class LetterOfExperienceService {
    private readonly apiUrl = this.config.letterOfExperienceUrl;

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {}

    generate(policyNumber: string): Observable<any> {
        const token = getAuthToken();
        
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        });
        
        const payload = { 
            policyNumber,
            env: 'Policy 360'
        };

        return this.http.post(this.apiUrl, payload, { headers });
    }
}
